import { getAuthToken } from '../common/auth'
import { showToast } from '../components/ToastNotification/ToastNotification'

// Flag to track if session expiry toast has been shown
let isSessionExpiredToastShown = false
let redirectTimeout = null

export const fetchWithAuth = async (url, options = {}) => {
  const headers = {
    ...(options.headers || {}),
    Authorization: `Bearer ${getAuthToken()}`,
  }
  const response = await fetch(url, { ...options, headers })

  if (response.status === 401) {
    // Only show toast and redirect if not already done
    if (!isSessionExpiredToastShown) {
      isSessionExpiredToastShown = true

      // Token expired or invalid
      showToast('error', 'Session expired. Please login again.')
      localStorage.removeItem('authToken')
      localStorage.removeItem('user')

      // Clear any existing redirect timeout
      if (redirectTimeout) {
        clearTimeout(redirectTimeout)
      }

      redirectTimeout = setTimeout(() => {
        window.location.href = '/login'
      }, 1000) // Give user time to see the toast
    }

    // Return a rejected promise to handle in calling code
    return Promise.reject(new Error('Session expired'))
  }

  return response
}

// Optional: Reset the flag when user logs in again
export const resetSessionExpiredFlag = () => {
  isSessionExpiredToastShown = false
  if (redirectTimeout) {
    clearTimeout(redirectTimeout)
    redirectTimeout = null
  }
}
